import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class GithubService {

  constructor(private http: Http) { }

  getUser(searchText): Observable<any>{
    const url = 'https://api.github.com/search/repositories?q='+searchText;

   return this.http.get(url).map(
        res=> {
            const data = res.json();
            console.log(data);
            return data;
        }
    )

   }
}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/service/github/github.service.ts